<template>
  <base-material-card
    color="primary"
    icon="mdi-format-list-checks"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        Adicionar Validação de Atributos MCPSE
      </div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="pb-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="titulo-validacao-mcpse"
              label="Título"
              outlined
              :error-messages="errors"
              v-model="nome"
            />
          </validation-provider>
        </v-col>

        <v-col cols="12" class="py-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
              id="tipo-validacao-mcpse"
              no-gutters
              outlined
              :items="bases"
              label="Tipo"
              v-model="tipo"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col cols="12" class="py-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-select
              id="origem-validacao-mcpse"
              no-gutters
              outlined
              :disabled="tipo == ''? true :false"
              :items="origens"
              label="Origem"
              v-model="origem"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>

        <v-col cols="12" class="py-0" v-show="origem">
          <v-alert dense outlined type="info" color="blue">
            <div v-if="tipo == 'Base Contábil' && origem != 'Arquivo'">
              A consulta selecionada deve conter os campos <b>TI, TUC, A1, A2, A3, A4, A5, A6</b> e opcionalmente <b>QTD Somatório</b> e <b>Centro Modular</b>.
            </div>
            <div v-else-if="tipo == 'Base Física' && origem != 'Arquivo'">
              A consulta selecionada deve conter os campos <b>TI, TUC, A1, A2, A3, A4, A5, A6</b> e opcionalmente <b>Centro Modular</b>.
            </div>

            <div v-if="tipo == 'Base Contábil' && origem == 'Arquivo'">
              O arquivo selecionado deve conter os campos <b>TI, TUC, A1, A2, A3, A4, A5, A6</b> e opcionalmente <b>QTD</b> e <b>CM</b>.
              <br>Obs: A coluna <b>CM</b> pode conter o nome de <b>Centro Modular</b> ou <b>CM</b> para ser validado.
              <br>Obs²: A coluna <b>QTD</b> pode conter o nome de <b>QTD Somatório</b> ou <b>QTD</b> para ser validado.
            </div>
            <div v-else-if="tipo == 'Base Física' && origem == 'Arquivo'">
              O arquivo selecionado deve conter os campos <b>TI, TUC, A1, A2, A3, A4, A5, A6</b> e opcionalmente <b>CM</b>.
              <br>Obs: A coluna <b>CM</b> pode conter o nome de <b>Centro Modular</b> ou <b>CM</b> para ser validado.
            </div>
          </v-alert>
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto" v-if="origem == 'Consulta'">
        <v-col cols="12" class="pb-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              label="Consulta"
              placeholder="Selecione uma consulta"
              outlined
              readonly
              v-model="consultaNome"
              @focus="openRelatoriosSelector()"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>
      <template v-if="origem == 'Arquivo'">
        <v-row align="center" class="mx-auto">
          <v-col md="6" sm="6" cols="12" class="py-0">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-file-input
                class="ml-n2"
                style="min-width: calc(100% + 8px) !important"
                @change="uploadNewFile"
                label="Arquivo CSV"
                placeholder="Selecione um arquivo CSV"
                outlined
                accept=".csv, .zip"
                v-model="arquivo"
                show-size
                truncate-length="30"
                :loading="uploadInProgress"
                loader-height="4"
                :success="arquivoId && arquivo ? true : false"
                :error-messages="errors"
              />
            </validation-provider>
            <!-- Validar se o upload do arquivo foi concluido -->
            <validation-provider v-slot="{ errors }" rules="min_value:1">
              <input 
                type="hidden" 
                name="validateUpload" 
                :value="arquivoId && arquivo ? 1 : 0"  
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col md="6" sm="6" cols="12" class="py-0">
            <general-encoding :encoding.sync="encoding" />
          </v-col>
        </v-row>

        <parametros-arquivo-csv
          class="pac-validacao-mcpse"
          :delimitador.sync="delimitador"
          :involucro.sync="involucro"
          :escape.sync="escape"
        />

      </template>
    </v-form>
    <general-relatorios-selector :activated.sync="relatoriosDialog" @selected="closeRelatoriosSelector($event)" />
  </base-material-card>
</template>

<script>
import ConfiguracoesService from "@/services/ConfiguracoesService.js";
import ArquivosService from "@/services/ArquivosService.js";

export default {
  name: "parametros-validacao",

  components: { 
    GeneralRelatoriosSelector: () => import("@/components/general/selectors/GeneralRelatoriosSelector.vue"),
    GeneralEncoding: () => import("@/components/general/GeneralEncoding.vue"),
    ParametrosArquivoCsv: () => import("@/components/general/GeneralParametrosArquivoCsv.vue")
  },

  mounted() {
    ConfiguracoesService.getCsvCamposPadroes()
      .then(response => {
        this.delimitador = response.data.campos.delimitador.valor;
        this.involucro = response.data.campos.involucro.valor;
        this.escape = response.data.campos.escape.valor;
      })
      .catch(err => {
        console.log("Erro ao recuperar campos padrões do arquivo csv: ", err);
        this.$toast.error("Erro ao recuperar campos padrões do arquivo csv.", "", { position: "topRight" });
      });
  },

  data() {
    return {
      nome: "",
      tipo: "",
      bases: ["Base Física", "Base Contábil"],
      origem: "",
      origens: ["Consulta", "Arquivo"],
      consulta: "",
      consultaNome: "",
      arquivo: undefined,
      arquivoId: "",
      encoding: "UTF-8",
      delimitador: ";",
      involucro: `"`,
      escape: `"`,
      validarQtd: false,
      validarCm: false,
      uploadInProgress: false,
      relatoriosDialog: false
    };
  },

  methods: {
    uploadNewFile() {
      if (!this.arquivo) return;

      this.arquivoId = "";
      this.uploadInProgress = true;

      let data = new FormData();
      data.append("file", this.arquivo);

      ArquivosService.uploadFile(data)
        .then(response => {
          this.arquivoId = response.data.arquivoId;
        })
        .catch(err => {
          console.log(err);
          
          if(err?.data?.cod_erro == 10000) {
            let msg = "Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.";
            this.$toast.error(msg,  "", { position: "topRight", timeout: 8000 });
          } else {
            this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" });
          }

          this.arquivo = undefined;
        })
        .finally(() => {
          this.uploadInProgress = false;
        });
    },

    openRelatoriosSelector() {
      this.relatoriosDialog = true;
    },

    closeRelatoriosSelector(event) {
      this.consulta = event.id;
      this.consultaNome = `#${event.id} - ${event.nome}`;

      this.relatoriosDialog = false;
    },

    exportData() {
      return {
        titulo: this.nome,
        tipo: this.tipo === "Base Física" ? "BASE FISICA" : "BASE CONTABIL",
        origem: this.origem.toUpperCase(),
        consulta_id: this.origem === "Consulta" ? this.consulta : "",
        arquivo_id: this.origem === "Arquivo" ? this.arquivoId : "",
        encoding: this.encoding,
        arquivo_delimitador: this.delimitador,
        arquivo_involucro: this.involucro,
        arquivo_escape: this.escape
      };
    }
  }
};
</script>

<style>
  .v-alert__icon {
    align-self: center;
  }

  .v-alert__content {
    align-self: center;
  }
  .pac-validacao-mcpse .col-sm-4,
  .pac-validacao-mcpse .col-12 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
</style>